// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"767dbab1","787":"530100dc"}[chunkId] + ".chunk.js";
};